<div class="pt-4 d-none d-xl-block filter-component">
  <nav class="d-flex justify-content-center w-100" role="navigation" aria-label="Primary">
    <ul class="nav nav-pills nav-top" id="group-list" role="tablist">
      <li
        class="nav-item"
        *ngFor="let group of groups; index as i"
      >
        <a
          routerLink="{{ lang }}/{{ group.routerNew }}"
          [ngClass]="{'active': checkGroup(group)}"
          class="nav-link upper-group-link rounded-0"
          id="group{{ i }}"
          type="button"
          role="tab"
          aria-selected="true"
          appCloseSidenav="MAIN"
          (click)="onClickGroup(group.group)"
        >
          {{ group.group | translate }}
        </a>
      </li>
    </ul>
    <aside class="links" aria-label="Language Selector">
      <app-language-selector></app-language-selector>
    </aside>
  </nav>
  <nav class="d-flex w-100 nav-member-parent" role="navigation" aria-label="Members">
    <div class="container">
      <ul class="nav nav-pills nav-top" id="member-list" role="tablist">
        <li
          class="nav-item"
          *ngFor="let member of selectedGroup?.members; index as j"
        >
          <a
            *ngIf="route"
            [class.active]="checkMember(member)"
            class="rounded-0 nav-member"
            id="member{{ j }}"
            data-toggle="pill"
            type="button"
            role="tab"
            aria-selected="true"
            appCloseSidenav="MAIN"
            routerLink="{{ lang }}/{{ member.routerLink }}"
            [attr.disabled]="member.routerLink ? null : true"
            [class.disabled]="!member.routerLink"
            (click)="onClickMember(member.title)"
          >
            {{ member.title | translate }}
          </a>
        </li>
      </ul>
    </div>
  </nav>
</div>
